/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { RouteObject } from 'react-router'
import TransactionFormPage from './TransactionFormPage'
import TransactionListPage from './TransactionListPage'

export const revenueRoutes: RouteObject[] = [
  {
    index: true,
    element: <TransactionListPage expense={false} />
  },
  {
    path: 'create',
    element: <TransactionFormPage expense={false} />
  },
  {
    path: ':id/*',
    children: [
      {
        path: 'edit',
        element: <TransactionFormPage expense={false} />
      }
    ]
  }
]
